export const patients_aws = {
  Auth: {
    mandatorySignIn: true,
    region: "us-west-2",
    userPoolId: "us-west-2_AgXnPCmk3",
    userPoolWebClientId: "751oae6pinp8t40lfmgmisdovd", //App Clied Id
    //identityPoolId: "Not made, we have make it",
  },
};
